import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "../pages/auth/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import Clients from "../pages/clients/Clients";
import Invoice from "../pages/invoices/Invoice";
import AdminLayout from "../layouts/AdminLayout";

function Protected({ children }) {

    const token = localStorage.getItem("token");

    if (!token) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default function AppRoutes() {

    return (
        <BrowserRouter>

            <Routes>

                {/* Login */}
                <Route path="/" element={<Login />} />

                {/* Dashboard */}
                <Route
                    path="/dashboard"
                    element={
                        <Protected>
                            <AdminLayout>
                                <Dashboard />
                            </AdminLayout>
                        </Protected>
                    }
                />

                {/* Clients */}
                <Route
                    path="/clients"
                    element={
                        <Protected>
                            <AdminLayout>
                                <Clients />
                            </AdminLayout>
                        </Protected>
                    }
                />

                {/* Invoices - Sidebar uses /invoices */}
                <Route
                    path="/invoices"
                    element={
                        <Protected>
                            <AdminLayout>
                                <Invoice />
                            </AdminLayout>
                        </Protected>
                    }
                />

                {/* New Invoice alias */}
                <Route
                    path="/invoices/new"
                    element={
                        <Protected>
                            <AdminLayout>
                                <Invoice />
                            </AdminLayout>
                        </Protected>
                    }
                />

                {/* Invoice alias */}
                <Route
                    path="/invoice"
                    element={
                        <Protected>
                            <AdminLayout>
                                <Invoice />
                            </AdminLayout>
                        </Protected>
                    }
                />

                {/* Unknown route */}
                <Route
                    path="*"
                    element={<Navigate to="/dashboard" replace />}
                />

            </Routes>

        </BrowserRouter>
    );
}
